import { Box, HStack, Text } from '@chakra-ui/react'
import { ParentTicketHeader } from '@/components/helpdesk/ParentTicket/ParentTicketHeader'
import { ParentTicketTable } from '@/components/helpdesk/ParentTicket/ParentTicketTable'
import { Pagination } from '@/components/tables'
import { useParentTickets } from '@/hooks/useParentTickets'

export default function ParentTicketList() {
  const {
    tickets,
    totalCount,
    meta,
    setPageFromUrl,
  } = useParentTickets()

  return (
    <Box p={6} w="100%" minW={0}>
      <ParentTicketHeader totalCount={totalCount} />
      <ParentTicketTable data={tickets} height="calc(100vh - 180px)" />

      <HStack
        justify="space-between"
        mt={3}
        pt={3}
        borderTop="1px solid"
        borderColor="gray.200"
        align="center"
      >
        <Text fontSize="sm" color="gray.600">
          Show <Box as="span" fontWeight="600">{meta.per_page}</Box> Results
        </Text>

        <Box minW="fit-content">
          <Pagination metas={meta} onClick={setPageFromUrl} />
        </Box>
      </HStack>
    </Box>
  )
}
